module.exports = __webpack_public_path__ + "media/sparks/circle-sparks--red-f5f99c30.svg";